if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        this.errorHtml = this.querySelector('template')?.content.firstElementChild.cloneNode(true);
        this.info = this.querySelector('.js-pickup-availability-info');
        this.pickupAvailabilityConfirmStore = this.querySelector('.pickup-availability__confirm-store');
        this.storeLocator = document.querySelector('my-store-locator');
        this.storeLocatorDrawer = document.querySelector('my-store-locator-drawer');
        this.storeConfirmationMessage = window.cartStrings.storeConfirmationMessage;
      }

      /** Paint from existing itemLocationsData so cart re-renders don't flash the loading state. */
      connectedCallback() {
        const itemKey = this.dataset?.itemKey;
        const preferredId = this.storeLocator?.preferredStoreId;
        const cached = itemKey && preferredId &&
          this.storeLocator.itemLocationsData?.[itemKey]?.find((l) => l.id === preferredId);
        if (!cached) return;
        if (!this.info) this.info = this.querySelector('.js-pickup-availability-info');
        this.renderPreview(cached);
      }

      renderError() {
        this.info.innerHTML = '';
        this.info.append(this.errorHtml);
      }

      renderLoading() {
        this.info.innerHTML = '';
        if (this.pickupAvailabilityConfirmStore) this.pickupAvailabilityConfirmStore.innerHTML = '';
        const loadingHtml = `
          <p class="caption">
            ${this.storeLocator.dataset.loadingText} <i class="fa fa-spinner fa-spin"></i>
          </p>
        `;
        const loadingNode = new DOMParser().parseFromString(loadingHtml, 'text/html').body.childNodes[0];
        this.info.append(loadingNode);
      }

      renderPreview(location) {
        let locationData = {...location};
        if (this.dataset?.cto) {
          if (locationData?.available) {
            this.classList.add('is-active');
          } else {
            this.classList.remove('is-active');
          }
          return;
        }

        if (this.dataset?.itemKey && locationData) {
          const itemLocationsData = this.storeLocator.itemLocationsData[this.dataset.itemKey];
          if (itemLocationsData) {
            const itemLocation = itemLocationsData.find((itemLocation) => itemLocation.id === location.id);
            if (itemLocation) {
              locationData = itemLocation;
            }
          }
        }
        const titleParagraph = this.querySelector('.apl-section-pickup-title');
        this.info.innerHTML = '';
        titleParagraph.lastChild.remove();
        if (this.pickupAvailabilityConfirmStore) this.pickupAvailabilityConfirmStore.innerHTML = '';
        let buttonText = this.storeLocator.dataset.viewStoreAvailabilityText;
        let unavailableHtml = '';
        let timeHtml = '';
        let stockHtml = '';
        let marlogHtml = '';
        let messageOverridden = false;
        if (locationData) {
          const itemsAdded = this.dataset?.itemQuantity ? parseInt(this.dataset.itemQuantity) : null;

          buttonText = locationData.name;

          let pickUpTimeTranslated = '';
          if (locationData.pickUpTime) {
            const key = locationData.pickUpTime;
            const languageKey = SDG.Data.language?.toLowerCase() || 'en';
            pickUpTimeTranslated = window.deliveryOptionsStrings?.[languageKey]?.[key] || locationData.pickUpTime;
          }

          let overridePickupMessage = this.dataset?.overridePickupMessage;
          const messageType = this.dataset?.messageType;
          if (!overridePickupMessage && messageType) {
            const languageKey = SDG.Data.language?.toLowerCase() || 'en';
            const pickupMessagesJson = JSON.parse(locationData.pickupMessages?.value || null);
            const pickupMessages = pickupMessagesJson?.[languageKey] || pickupMessagesJson?.['en'];
            switch(messageType) {
              case 'cto':
                overridePickupMessage = pickupMessages?.cto;
                break;
              case 'preorder':
                overridePickupMessage = pickupMessages?.preOrder;
                break;
              case 'in stock':
                overridePickupMessage = pickupMessages?.inStock;
                break;
            }
          }
          // Preorder/launch has no store stock, so skip the pickup-offered gate
          if (overridePickupMessage && (messageType === 'preorder' || locationData.productPickupOfferedAtLocation) && !(messageType === 'in stock' && !locationData.available)) {
            timeHtml = `
              <div class="caption">
                <div class="pickup-availability__time apl-section-pickup-availability-time">
                  ${overridePickupMessage}
                </div>
              </div>
            `;
            if (window.location.href.includes('/cart')) {
              this.pickupAvailabilityConfirmStore.innerHTML = this.storeConfirmationMessage;
            }
            messageOverridden = true;
          } else if (locationData.available) {
            if(window.location.href.includes('/cart')){

              const marlogAvailable = document.querySelectorAll(`.wd-marlog-available[data-item-key="${this.id.replace('pickup_id_','')}"]`);
                marlogAvailable.forEach(item => {
                  item.style.display = 'none';
                });
            }else{   
              const marlogAvailable = document.querySelectorAll(".wd-marlog-available");
                marlogAvailable.forEach(item => {
                  item.style.display = 'none';
                });
            }
            this.dataset.quantityAvailable = locationData.quantityAvailable;
            const isEilat = locationData.name.includes("אילת");
            timeHtml = `
              <p class="caption">
                <span class="pickup-availability__time apl-section-pickup-availability-time">
                  ${!isEilat ? this.storeLocator.dataset.pickUpAvailableHtml : this.storeLocator.dataset.pickUpAvailableEilat}
                </span>
              </p>
            `;
            //wedev - hide stock html by customer request, commented in case they change their mind
            // if (locationData.quantityAvailable === 1) {
            //   const oneStockText = this.storeLocator.dataset.onlyOneLeftHtml;
            //   stockHtml = `
            //     <p class="caption">
            //       <span class="pickup-availability__stock apl-section-pickup-availability-stock">
            //         ${oneStockText}
            //       </span>
            //     </p>
            //   `;
            // }else if (locationData.quantityAvailable < 10) {
            //   const stockText = this.storeLocator.dataset.lowStockHtml.replace('{{ quantity }}', locationData.quantityAvailable);
            //   stockHtml = `
            //     <p class="caption">
            //       <span class="pickup-availability__stock apl-section-pickup-availability-stock">
            //         ${stockText}
            //       </span>
            //     </p>
            //   `;
            // }
            //end of wedev - hide stock html by customer request, commented in case they change their mind
            if (itemsAdded && itemsAdded > locationData.quantityAvailable) {
              timeHtml = `
                <p class="caption">
                <span class="pickup-availability__error apl-section-pickup-availability-error">
                  ${this.dataset.error}
                </span>
                </p>
              `;
            }
            if (window.location.href.includes('/cart')) {
              this.pickupAvailabilityConfirmStore.innerHTML = this.storeConfirmationMessage;
            }
          } else if (locationData.available === false) {
            const overrideUnavailableMessage = this.dataset?.overrideUnavailableMessage;
            const stockAtMarlog = locationData.marlogStock && Number(locationData.marlogStock) > 0 ? Number(locationData.marlogStock) : null;
            const isEilat = locationData.name.includes("אילת");
            if(stockAtMarlog && !isEilat){

              unavailableHtml = `
                <p class="caption unavailable apl-section-pickup-availability-unavailable">
                <span class="pickup-availability__time apl-section-pickup-availability-time">
                  זמין לרכישה. יגיע לסניף תוך כ-2 ימי עסקים.
                  <br/>
                  נעדכן אותך כשההזמנה מוכנה.
                </span>
              </p>
              `;
            }else{
              unavailableHtml = `
                <p class="caption unavailable apl-section-pickup-availability-unavailable">
                  ${overrideUnavailableMessage ? (`<span class="pickup-availability__unavailable-override">${overrideUnavailableMessage}</span>`) : this.storeLocator.dataset.unavailableText}
                </p>
              `;

            }
            if (window.location.href.includes('/cart')) {    
              const marlogAvailable = document.querySelectorAll(`.wd-marlog-available[data-item-key="${this.id.replace('pickup_id_','')}"]`);
              if(stockAtMarlog){
                marlogAvailable.forEach(item => {
                  item.style.display = 'flex';
                });
              }else{
                marlogAvailable.forEach(item => {
                  item.style.display = 'none';
                });
              }
            }else{
              const marlogAvailable = document.querySelectorAll(".wd-marlog-available");
              if(stockAtMarlog){
                marlogAvailable.forEach(item => {
                  item.style.display = 'flex';
                });
              }else{
                marlogAvailable.forEach(item => {
                  item.style.display = 'none';
                });
              }

            }
            messageOverridden = !!overrideUnavailableMessage;
          }

        }

        const infoHtml = `
          <div class="pickup-availability-info-details apl-section-pickup-availability">
            ${unavailableHtml}
            ${timeHtml}
            ${stockHtml}
          </div>
        `;
        const storeLocatorDrawerButton = `
          <button
            class="js-my-store-locator-drawer-btn pickup-availability-button link link--text apl-section-pickup-availability-cta"
            aria-haspopup="dialog"
            aria-label="איסוף מהסניף ${buttonText} לחץ לבחירת סניף אחר"
            ${this.dataset?.itemKey ? `data-item-key="${this.dataset.itemKey}"` : ''}
          >
            <span class="underlined-text">${buttonText}</span>
            ${this.classList.contains('cto__pickup') ? `<i class="fa-solid fa-chevron-right cto-chevron"></i>` : ''}
          </button>`
        
        const infoNode = new DOMParser().parseFromString(infoHtml, 'text/html').body.childNodes[0];
        const locationNameTrigger = new DOMParser().parseFromString(storeLocatorDrawerButton,'text/html').body.childNodes[0];
        this.info.append(infoNode);
        titleParagraph.append(locationNameTrigger);

        if (messageOverridden) {
          this.classList.add('is-overridden');
        } else {
          this.classList.remove('is-overridden');
        }

        const button = this.querySelector('button');
        if (button) {
          button.addEventListener('click', async (evt) => {
            evt.preventDefault();
            const drawer = this.storeLocatorDrawer;
            const locator = this.storeLocator;
            if (!drawer || !locator) return;

            if (typeof window.Eilat_handler?.getCart === 'function') {
              try {
                await window.Eilat_handler.getCart();
              } catch (_) {}
            }
            drawer.selectedItemLocationsKey = null;
            if (this.dataset?.itemKey) {
              const selectedItemLocationsData = locator.itemLocationsData[this.dataset.itemKey];
              if (selectedItemLocationsData) {
                drawer.selectedItemLocationsKey = this.dataset.itemKey;
                drawer.updateStoreDetails(selectedItemLocationsData, '');
              }
            }
            drawer.show(evt.currentTarget ?? null);
          });
        }
      }
    }
  );
}
